module.exports = __webpack_public_path__ + "cancellara-live-dist/img/logoEdenred.e3eff079.png";